import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JoiTemplate, getJoiTemplate, ColorTemplateKeys, FontDropdownOptions, ColorTemplate, TemplateFont, FontCSS } from 'globals/store/publish.data';
import { DropdownOption } from 'globals/store/programs.data';
import { ColorSelectorComponent } from './color-selector.component';
import { DropdownComponent } from '../misc/dropdown.component';
import { FindByIdPipe } from 'src/app/services/pipes/findById.pipe';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { BrandingControlsWrapperComponent } from './brand-controls-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'brand-template',
    template: `
<branding-controls-wrapper *ngIf="!selectedViewOnly"
  [selected]="selected"
  [isAccountDefault]="isAccountDefault"
  [hideDelete]="template.id === 'joi'"
  [deleteTitle]="deleteTitle" 
  [deleteText]="deleteText"
  [onAccount]="onAccount" 
  (delete)="delete.emit()"
  (setAsAccountDefault)="setAsAccountDefault.emit()"
  (select)="select.emit()"
>
  <joi-input class="big-title" 
    [italicPlaceholder]="true" 
    [type]="'textarea'" 
    [disabled]="readOnly || !onAccount" 
    [(model)]="template.name" 
    [placeholder]="'Fonts and colors template name...'" 
    (joiChange)="updateTemplate.emit()"
  ></joi-input>
  <ng-container *ngTemplateOutlet="body"></ng-container>
</branding-controls-wrapper>

<ng-container *ngIf="!!selectedViewOnly">
  <ng-container *ngTemplateOutlet="body"></ng-container>
</ng-container>

<ng-template #body>
  <div class="fonts">
    <div class="font">
      <h5>Header Font:</h5> 
      <dropdown 
        [disableDropdown]="!onAccount || readOnly || template.id === 'joi'" 
        [selections]="FontDropdownOptions" 
        [selected]="FontDropdownOptions | findById:template.headerFont" 
        [ngClass]="{ displayOnly: selectedViewOnly }"
        (select)="updateHeaderFont($event)"
      ></dropdown>
      <div *ngIf="!!selectedViewOnly" [style.font-family]="FontCSS[template.headerFont]">This is your heading font</div>
    </div>
    <div class="font">
      <h5>Body Font:</h5> 
      <dropdown 
        [disableDropdown]="!onAccount || readOnly || template.id === 'joi'" 
        [selections]="FontDropdownOptions" 
        [selected]="FontDropdownOptions | findById:template.font" 
        [ngClass]="{ displayOnly: selectedViewOnly }"
        (select)="updateBodyFont($event)"
      ></dropdown>
      <div *ngIf="!!selectedViewOnly" [style.font-family]="FontCSS[template.font]">This is your body font</div>
    </div>
  </div>
  <div class="colors">
    <color-selector *ngFor="let key of keys" 
      [key]="key" 
      [color]="template[key]"
      [pickerOpen]="onAccount && !readOnly && template.id !== 'joi' && openKey === key"
      [readOnly]="readOnly"
      (open)="openKey = key" 
      (changeColor)="changeColor(key, $event)"
    ></color-selector>
  </div>
</ng-template>
`,
    styles: [`
.colors { display: flex; flex-wrap: wrap; margin: 0 80px; }
:host { display: flex;  flex-direction: column; }
.fonts { display: flex; flex-direction: column; }
.font { display: flex; align-items: center; justify-content: center; margin-bottom: 20px; }
.font dropdown { margin: 0 20px; }
.big-title { margin: 10px 0; }
.displayOnly { background: var(--background); padding: 2px 5px; }
color-selector { margin: 25px; flex: 1; white-space: nowrap; }
`],
    styleUrls: ['./branding-card-controls.scss'],
    standalone: true,
    imports: [ColorSelectorComponent, DropdownComponent, CommonModule, FindByIdPipe,JoiInputComponent, BrandingControlsWrapperComponent],
})
export class BrandTemplateComponent {
  @Input() template: JoiTemplate = getJoiTemplate()
  @Input() isAccountDefault = false
  @Input() onAccount = false
  @Input() selected: boolean

  @Input() readOnly = true
  @Input() selectedViewOnly = false
  @Output() updateTemplate: EventEmitter<void> = new EventEmitter()
  @Output() setAsAccountDefault: EventEmitter<void> = new EventEmitter()
  @Output() select: EventEmitter<void> = new EventEmitter() 
  @Output() delete: EventEmitter<void> = new EventEmitter() 

  deleteTitle: string = 'Delete Brand Template'
  deleteText: string

  FontDropdownOptions = FontDropdownOptions
  FontCSS = FontCSS

  hasChanges = false
  keys = ColorTemplateKeys
  openKey = ''


  updateHeaderFont(font: DropdownOption<TemplateFont>) {
    this.template.headerFont = font.id
    this.updateTemplate.emit()
  }

  updateBodyFont(font: DropdownOption<TemplateFont>) {
    this.template.font = font.id
    this.updateTemplate.emit()
  }

  changeColor(key: keyof ColorTemplate, color: string) {
    this.openKey = ''
    if (color && color !== this.template[key]) { 
      this.template[key] = color
      this.updateTemplate.emit()
    }
  }
}
